import React, { useState } from "react";
import Sidebar from "./SideBar";
import TopBar from "./TopBar";
import HomePage from ".//Current Training/HomePage";
import TrainingHistory from "./Training History/TrainingHistory";
import "./CSS/MainContainer.css";
import MainContainerMobile from "./MainContainerMobile";
import useHeartbeat from "./useHeartbeat"; // update path if needed

const MainContainer = ({ onAppReload, userId, profile, setShowNameModal, isGuest, isMobile, refreshTrigger, setProfile, isOnline }) => {
  const [selectedPage, setSelectedPage] = useState("currentTraining");
  const [isDemo, setIsDemo] = useState(false);
  const [restoreRequest, setRestoreRequest] = useState(null);
  useHeartbeat(userId);

  const handleDesktopRestore = (session) => {
    if (!session?.id) return;
    setSelectedPage("currentTraining");
    setRestoreRequest({ id: session.id, nonce: Date.now() });
  };

  if (isMobile) {
    return (
      <MainContainerMobile
        userId = {userId}
        onAppReload={onAppReload}
        profile={profile}
        setShowNameModal={setShowNameModal}
        isGuest={isGuest}
        isMobile={isMobile}
        refreshTrigger={refreshTrigger}
        setProfile={setProfile}
        setIsDemo={setIsDemo}
        isDemo={isDemo}
        isOnline={isOnline}
      />
    );
  }

  return (
    <div className="main-wrapper">
      <Sidebar selectedPage={selectedPage} setSelectedPage={setSelectedPage} />
      <div className="content-container">
        <TopBar
          profile={profile}
          setShowNameModal={setShowNameModal}
          setProfile={setProfile}
        />
        <div
          style={{
            display: selectedPage === "currentTraining" ? "block" : "none",
          }}
        >
          <HomePage
            onAppReload={onAppReload}
            profile={profile}
            isGuest={isGuest}
            isOnline={isOnline}
            refreshTrigger={refreshTrigger}
            userId={userId}
            isDemo={isDemo}
            setIsDemo={setIsDemo}
            restoreRequest={restoreRequest}
          />
        </div>
        <div
          style={{
            display: selectedPage === "trainingHistory" ? "block" : "none",
          }}
        >
          <TrainingHistory userId={userId} onRestore={handleDesktopRestore} isOnline={isOnline} />
        </div>
      </div>
    </div>
  );
};

export default MainContainer;
